import React from 'react'
import "./compo.css"

const Plessure = () => {
  return (
    <div className='ple'>Plessureerthrthrjhejtyjrtjryjtyjtyjtjtyjtyjtyjtyjtyjtjtjtjtjtjtyjtyjtjtyjtyjtyjtyjtyjtyjtyjt</div>
  )
}

export default Plessure
